// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__gndGx","backanime":"Modal_backanime__8lRkS","modal":"Modal_modal__ZbNPS","modalanime":"Modal_modalanime__QxMHI"};